'use strict'

define ['./file.scss'], () ->
  (RentappService, $state, $filter, Upload, RENTAPPLICATION_API_URL) ->
    restrict: "E"
    template: require("./file.jade")
    scope: {field: "=", mode: "@", index: "=", stage: "="}
    link: (scope, element, attrs) ->

      if scope.field.value
        scope.filename = _.replace(scope.field.value , 'form-uploads/', '')
      
      scope.remove = () ->
        scope.field.value = null

      scope.upload = (file) ->
        if !file
          scope.error = "Upload file size exceeds maximum allowed size 5mb"
        else
          scope.uploading = true
          Upload.upload
            url: "#{RENTAPPLICATION_API_URL}/api/v1/attachment/upload/"
            file: file
          .then((resp) ->
            scope.field.value = resp.data.filenames[0]
            scope.error = ''
          , (err) ->
            if err.status == 400
              scope.error = err.data.error
          , (evt) ->
            scope.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
          )
          .then ->
            scope.uploading = false



// WEBPACK FOOTER //
// ./directives/freeforms/file/file.coffee